/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ChartMixedSolidV6 = (props) => (
  <Icon {...props} name="Chart Mixed Solid V6">
    <path d="M10.597 6.753c-.328.312-.831.322-1.197.047L6.019 4.266 1.625 7.754a.955.955 0 0 1-1.406-.156c-.345-.403-.275-1.031.156-1.378l5-4A1.001 1.001 0 0 1 6.6 2.201l3.381 2.534 4.394-3.515c.431-.345 1.059-.275 1.378.156a.955.955 0 0 1-.156 1.406l-5 3.972zM5 8a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0V8zm-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3zm10-1v4a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0zm2-2a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0V8z" />
  </Icon>
);

export default ChartMixedSolidV6;
